import { AxiosRequestConfig } from 'axios';
import { ENV } from 'src/env';

export const HTTP_CODE = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  PAYMENT_REQUIRED: 402,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
};

export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_HOUR = 'YYYY-MM-DD HH:mm:ss';
export const HOUR_MIN = 'HH:mm';
export const FULL_MONTH = 'DD MMMM YYYY';
export const FULL_MONTH_HOUR = 'DD MMMM YYYY, HH:mm';

export const config: AxiosRequestConfig = {
  baseURL: `${ENV.API.HOST}` || 'http://localhost:3000',
  headers: {
    'Content-Type': 'application/json',
  },
};

export const UPLOAD_MODULE = {
  CLASS_TOPIC_CONTENT: 'CLASS_TOPIC_CONTENT',
  VIDEO_ARCHIVE: 'VIDEO_ARCHIVE',
  CERTIFICATE: 'CERTIFICATE',
  PROFILE_IMG: 'PROFILE_IMG',
  PAGER_DOCUMENT: 'PAGER_DOCUMENT',
  OTHERS: 'OTHERS',
};

export const STORAGE_KEY = {
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  AUTH_ME_INFO: 'AUTH_ME_INFO',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
};

export const PER = {
  DEFAULT: 100,
  USER: 10,
};

export const imageTypes = ['image/png', 'image/jpeg'];
export const pdfType = ['application/pdf'];
export const videoType = ['video/mp4', 'video/quicktime'];
export const excelType = [
  'application/excel',
  'application/vnd.ms-excel',
  'application/x-excel',
  'application/x-msexcel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
export const wordType = [
  'application/doc',
  'application/ms-doc',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];
export const fileSize = 10; //Mb

export enum CONTENT_TYPE {
  // eslint-disable-next-line unused-imports/no-unused-vars
  PDF = 'PDF',
  // eslint-disable-next-line unused-imports/no-unused-vars
  VIDEO = 'VIDEO',
  // eslint-disable-next-line unused-imports/no-unused-vars
  IMAGE = 'IMAGE',
  // eslint-disable-next-line unused-imports/no-unused-vars
  ROLEPLAY = 'ROLEPLAY',
  /** A live Q&A session: ask, thumbs-up, ranked live. */
  // eslint-disable-next-line unused-imports/no-unused-vars
  QNA = 'QNA',
  // eslint-disable-next-line unused-imports/no-unused-vars
  FORUM = 'FORUM',
  // eslint-disable-next-line unused-imports/no-unused-vars
  POLL = 'POLL',
  // eslint-disable-next-line unused-imports/no-unused-vars
  RATING = 'RATING',
}

export const CONTENT_TYPE_OPTIONS = Object.values(CONTENT_TYPE).map((type) => ({
  value: type,
  key: type,
  text: type,
}));

export const PATH = {
  HOME: '/',
  LOGIN: '/login',
  RESET_PASSWORD: '/reset-password',
  REGISTER: '/register',
  HANDLE: '/handle',
  VERIFICATION: '/account-verification',
  NOT_FOUND: '/404',
  FORBIDDEN: '/403',
  INTERNAL_SERVER_ERROR: '/500',
  TERM_AND_POLICY: '/term_and_policy',
  // no '/' for route is authenticated
  LIBRARY: 'library',
  ALL_COURSES: 'all_courses',
  MY_COURSES: 'my_courses',
  ASSESSMENT: 'assessment',
  DIRECTORY: 'directory',
  JOBS: 'jobs',
  FAQS: 'faqs',
  CLASS: 'class',
  SETTING: 'setting',
  CHECKOUT: 'checkout',
  PAYMENT: 'payment',
  PAYMENT_SUCCESS: 'payment_success',
  PAYMENT_EXTENSION: 'payment_extension',
  ISSUES: 'issues',
  COMPANIES: 'companies',
  CONNECT: 'connect',
};

export const PLATFORM = {
  ACADEMY: 'academy',
  JENO: 'jeno',
  JENO_ADMIN: 'jeno-admin',
};

export const SOCIAL = {
  GOOGLE: 'Google',
};

export const EMAIL_REGEX =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])/;

export const FREE_PRICE = 0;

export const ASSESSMENT_TIME = 30 * 60;
export const ASSESSMENT_SCORE = 0.85;

export const NOTIFICATION_TYPE = {
  new_class_user: 'new_class_user',
  new_week_topic: 'new_week_topic',
  new_class_topic: 'new_class_topic',
  new_class_topic_content: 'new_class_topic_content',

  new_discussion_reply: 'new_discussion_reply',
  new_discussion_mention: 'new_discussion_mention',
  new_homework_comment: 'new_homework_comment',
  new_homework_reply: 'new_homework_reply',
  new_homework_mention: 'new_homework_mention',

  new_user_issue: 'new_user_issue',
} as const;
